import Link from "next/link"
import React from "react"
import { buildForgotPasswordPagePath } from "../../../../root/routing/urls"
import { getQueryParam } from "../../../../utils/url"
import { EditorialLabel } from "../../../contents"
import LoginForm from "../LoginForm"

interface Props {
  loginCallback?: () => void
  resetPwdCallback?: () => void
  resetPwdRedirectUrl?: string
}

const loginRedirectUrl = () => {
  const redirectUrl = getQueryParam(window.location, "returnUrl")
  if (redirectUrl) {
    return redirectUrl
  }

  if (window.location.pathname.toLowerCase().includes("/checkout/")) {
    return undefined
  }
  return "/profile"
}

const LoginPanel = ({
  loginCallback,
  resetPwdCallback,
  resetPwdRedirectUrl,
}: Props) => {
  const [loginReturnUrl, setLoginReturnUrl] = React.useState<string>()

  React.useEffect(() => {
    setLoginReturnUrl(loginRedirectUrl())
  }, [])

  return (
    <>
      <EditorialLabel scope="account" id="login" variant="h4" />
      <EditorialLabel
        variant="body2"
        weight="normal"
        className="pt-1 pb-2"
        scope="account"
        id="login-message"
      />
      <LoginForm
        callback={loginCallback}
        redirectUrl={loginReturnUrl}
        forgotPasswordControl={
          <div className="my-1 text-right">
            <Link
              href={buildForgotPasswordPagePath({
                returnUrl: resetPwdRedirectUrl,
              })}
              passHref
            >
              <a onClick={resetPwdCallback}>
                <EditorialLabel
                  scope="account"
                  id="forgot-password"
                  variant="body2"
                  weight="bold"
                />
              </a>
            </Link>
          </div>
        }
      />
    </>
  )
}

export default LoginPanel
